import { useEffect } from 'react';

/**
 * Drop-in JSON-LD structured data injector.
 * Mounts a <script type="application/ld+json"> tag on render and removes it on unmount.
 * Multiple instances on a page are supported (each gets its own script tag).
 */
const JsonLd = ({ schema, id }) => {
  useEffect(() => {
    if (!schema) return undefined;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    if (id) script.dataset.jsonldId = id;
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, [schema, id]);

  return null;
};

export default JsonLd;
